/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@app/config/store';
import { email } from '@app/dto/common.dto';
import { AuthService } from '@app/services/auth.service';
import { CommonService } from '@app/services/common.service';
import { MgmtService } from '@app/services/mgmt.service';
import { LoginResp } from '@app/types/auth.type';
import { Business_Context, Company, Entity } from '@app/types/global.type';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule],
  providers: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  private router = inject(Router);
  private store = inject(Store);
  private authSvc = inject(AuthService);
  private mgmtSvc = inject(MgmtService);
  commonSvc = inject(CommonService);

  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [email]),
    password: new FormControl('', []),
  });

  entityList!: Entity[];

  async login() {
    const payload = this.loginForm.value;
    this.authSvc.login(payload).subscribe(async (resp: LoginResp) => {
      if (resp) {
        this.store.setUser(resp);
        const businessObj: Business_Context = {
          companyid: String(resp?.companyid),
          companyName: '',
          rootCompanyName: '',
          rootCompanyId: resp?.rootCompanyid,
          gstinNo: '',
          registrationDate: '',
        };
        this.store.setBusiness(businessObj);
        this.store.setSelectedEntity({
          company: resp?.rootCompanyName,
          companyid: resp?.rootCompanyid,
        });
        this.entityList = await lastValueFrom(this.mgmtSvc.getEntityList());
        this.fetchBusinessHierarchy(businessObj.rootCompanyId.toString() ?? null);
        this.store.setBusinessEntityList(this.entityList ?? []);
        // let activeEntity =
        //   this.entityList.find((item: Entity) => {
        //     return item.companyid === this.store.businessContext()?.rootCompanyId;
        //   }) ?? null;
        // if (!activeEntity) {
        //   activeEntity = this.entityList[0];
        // }
        // this.store.setSelectedEntity(activeEntity);
        this.router.navigate(['/sapphire']);
      }
    });
  }

  fetchBusinessHierarchy(rootCompanyId: string) {
    this.mgmtSvc.getBusinessHierarchy({ companyid: rootCompanyId }).subscribe({
      next: (resp: any) => {
        const company: Company = (resp && resp.response) ?? null;
        this.store.setCompany(company);
      },
    });
  }
}
